<template>
    <form v-if="viewForm">
        <div class="input_item">
            <div class="p-float-label with-button">
                <InputText id="name" type="text" v-model="formData.name"/>
                <label for="name">{{ $t("Contact.Name") }}</label>
            </div>
        </div>

        <div class="input_item">
            <div class="p-float-label with-button">
                <InputText id="subject" type="text" v-model="formData.subject"/>
                <label for="subject">{{ $t("Contact.Subject") }}</label>
            </div>
        </div>

        <div class="input_item">
            <div class="p-float-label with-button">
                <InputText id="email" type="email" v-model="formData.email"/>
                <label for="email">{{ $t("Contact.Email") }}</label>
            </div>
        </div>

        <div class="input_item">
            <div class="p-float-label with-button">
                <InputText id="uid" type="text" v-model="formData.uid"/>
                <label for="uid">{{ $t("Contact.UID") }}</label>
            </div>
        </div>

        <div class="input_item">
            <div class="p-float-label with-button">
                <Textarea id="body" v-model="formData.body" :autoResize="true" rows="5" />
                <label for="body">{{ $t('Contact.Body') }}</label>
            </div>
        </div>


        <Button
            type="button"
            :label="$t('Contact.Send')"
            class="p-button-outlined submit"
            @click="onClickContactSend"
            />
    </form>
    <div class="complete" v-if="!viewForm">
        <h2>Thank you!</h2>
    </div>
</template>

<script>
import {
    ref,
    onMounted,
    reactive,
    computed,
} from 'vue';
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import TreeSelect from 'primevue/treeselect';
import Textarea from 'primevue/textarea';
import AutoComplete from 'primevue/autocomplete';
import axios from "axios";
import Message from 'primevue/message';
import Chips from 'primevue/chips';
import { useToast } from "primevue/usetoast";
import { errorToast } from './../../itemListError.js';

export default {
    components: {
        Button,
        InputText,
        TreeSelect,
        AutoComplete,
        Message,
        Chips,
        Textarea,
    },
    setup(props) {
        const toast = useToast();
        const viewForm = ref(true);

        const formData = reactive({
            name: "",
            subject: "",
            email: "",
            body: "",
            uid: "",
        })

        const load = () => {
        }
        onMounted(load);

        const onClickContactSend = function() {
            const postData = {
                name: formData.name,
                subject: formData.subject,
                email: formData.email,
                body: formData.body,
                uid: formData.uid,
            }
            axios.post(
                '/api/contact',
                postData,
            ).then(res => {
                viewForm.value = false;
                toast.add({severity: 'info', summary: 'Success', detail: 'Message Send', life: 3000});
            }).catch(error => {
                errorToast(error.response.data, toast);
            })
        }

        return {
            formData,
            onClickContactSend,
            viewForm,
        }
    },
}
</script>

<style lang="scss">
.p-chips .p-chips-multiple-container .p-chips-token {
    margin-top: 4px;
}
</style>
